import { render, staticRenderFns } from "./ViewerDirect.vue?vue&type=template&id=320ca337"
import script from "./ViewerDirect.vue?vue&type=script&lang=js"
export * from "./ViewerDirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports